// 德语
import deLocale from 'element-ui/lib/locale/lang/de'


const de = {
  // ============= 登录 start ============
  "验证码": "Verifizierungscode",
  "登录": "Anmeldung",
  "请输入验证码": "Bitte tragen Sie den Verifizierungscode ein",
  "验证码不正确!": "Falscher Verifizierungscode!",
  "请输入账号": "Bitte geben Sie Ihre Kontonummer ein",
  "请输入密码": "Bitte geben Sie Ihr Passwort ein",
  "访问地址有误，请在shop后台核实": "Die Zugriffsadresse ist falsch, bitte überprüfen Sie im Shop-Backend",
  // ============= 登录 end ============

  // ============= Layout start ============
  "全屏模式": "Vollbildmodus",
  "首页": "Startseite",
  "此操作将退出登录, 是否继续?": "Diese Aktion wird die Abmeldung durchführen, möchten Sie fortfahren?",
  "已取消退出": "Abmeldung abgebrochen",
  "您有一个新订单": "Sie haben eine neue Bestellung",
  "无法获取当前门店信息，请重新登录": "Aktuelle Geschäftsinformationen können nicht abgerufen werden, bitte melden Sie sich erneut an",
  "收银台": "Kasse",
  "收银": "Kassieren",
  "桌台": "Tisch",
  "订单": "Bestellung",
  // ============= Layout end ============

  // ============= 首页 start ============
  "查询会员": "Mitglied suchen",
  "商品改价": "Preis ändern",
  "商品删行": "Artikel löschen",
  "整单取消": "Bestellung stornieren",
  "取单": "Bestellung abholen",
  "挂单": "Bestellung halten",
  "折扣": "Rabatt",
  "抹零": "Abrunden",
  "请输入内容": "Bitte geben Sie den Inhalt ein",
  "收银员": "Kassierer",
  "店内就餐": "Speisen im Restaurant",
  "打包带走": "Mitnehmen",
  "商品名称": "Artikelname",
  "商品价格": "Artikelpreis",
  "商品数量": "Artikelmenge",
  "应收": "Gesamtbetrag",
  "包装费": "Verpackungsgebühr",
  "优惠": "Rabatt",
  "数量": "Menge",
  "件": "Stück",
  "实收": "Erhaltener Betrag",
  "收款": "Zahlungseingang",
  "请选择商品": "Bitte wählen Sie Artikel aus",
  "确定要删除": "Sind Sie sicher, dass Sie löschen möchten",
  "提示": "Hinweis",
  "确定": "Bestätigen",
  "取消": "Abbrechen",
  "请先将购物车内的商品挂单或结账后再取单": "Bitte halten oder zahlen Sie die Artikel im Warenkorb, bevor Sie die Bestellung abholen",
  "确定要整单取消吗?": "Sind Sie sicher, dass Sie die gesamte Bestellung stornieren möchten?",
  "请输入会员手机号查询会员，输入完毕后点击确认": "Bitte geben Sie die Telefonnummer des Mitglieds ein, um es zu suchen, klicken Sie dann auf Bestätigen",
  "请输入会员手机号": "Bitte geben Sie die Telefonnummer des Mitglieds ein",
  "会员昵称": "Mitgliedsname",
  "余额总计": "Gesamtsaldo",
  "退出": "Ausgang",
  "该用户不存在": "Dieser Benutzer existiert nicht",
  "折扣抹零": "Rabatt/Abrundung",
  "当前价格": "Aktueller Preis",
  "改价": "Preis ändern",
  "实付价格": "Tatsächlicher Preis",
  "请输入实付价格": "Bitte geben Sie den tatsächlichen Preis ein",
  "优惠折扣": "Rabattrate",
  "请输入优惠折扣": "Bitte geben Sie die Rabattrate ein",
  "抹分": "Abrunden auf die nächste volle Einheit",
  "抹角": "Abrunden auf den nächsten vollen Dollar",
  "四舍五入到角": "Runden auf die nächste volle Einheit",
  "四舍五入到元": "Runden auf den nächsten vollen Dollar",
  "确 定": "Bestätigen",
  "价格不能为空": "Preis darf nicht leer sein",
  "折扣不能为空": "Rabatt darf nicht leer sein",
  "修改价格": "Preis ändern",
  "本次售价": "Aktueller Verkaufspreis",
  "请输入本次售价": "Bitte geben Sie den aktuellen Verkaufspreis ein",
  "清空": "Leeren",
  "确认": "Bestätigen",
  "商品详情": "Artikeldetails",
  "单位": "Einheit",
  "规格": "Spezifikationen",
  "加料": "Zusätzliche Zutaten",
  "取 消": "Abbrechen",
  "现金收款": "Bargeldzahlung",
  "余额收款": "Saldozahlung",
  "其他方式": "Andere Methoden",
  "应收金额": "Gesamtbetrag fällig",
  "用户通过店内扫码等方式进行支付，确认用户支付成功后，点击确认付款即可完成付款操作。": "Kunden können über QR-Code und andere Methoden im Geschäft bezahlen. Nach Bestätigung der erfolgreichen Zahlung, klicken Sie auf 'Zahlung bestätigen', um die Transaktion abzuschließen.",
  "微信支付": "WeChat-Zahlung",
  "支付宝支付": "Alipay",
  "pos刷卡": "POS-Kartenzahlung",
  "请输入会员ID号查询会员，输入完毕后点击确认": "Bitte geben Sie die Mitglieds-ID ein, um das Mitglied zu suchen, klicken Sie dann auf Bestätigen",
  "请输入会员ID": "Bitte geben Sie die Mitglieds-ID ein",
  "登录会员仅作为积分累计，无法享受其他优惠。": "Angemeldete Mitglieder können nur Punkte sammeln und sind nicht für andere Rabatte berechtigt.",
  "取消收款": "Zahlung abbrechen",
  "订单总价": "Gesamtpreis der Bestellung",
  "挂单时间": "Zeit der Bestellhalterung",
  "删除": "Löschen",
  "多语言小票打印": "Druck von mehrsprachigen Quittungen",
  "打印语言": "Drucksprache",
  "中文": "Chinesisch",
  "英语": "Englisch",
  "德语": "Deutsch",
  "法语": "Französisch",
  "西班牙语": "Spanisch",
  "意大利语": "Italienisch",
  "克罗地亚": "Kroatisch",
  "斯洛文尼亚": "Slowenisch",
  "匈牙利语": "Ungarisch",
  "塞尔维亚语": "Serbisch",
  // ============= 首页 end ============

  // ============= 桌台 start ============
  "未开台": "Nicht geöffnet",
  "已开台": "Tisch geöffnet",
  "就餐中": "Essen",
  "刷新": "Aktualisieren",
  "整单清空": "Gesamte Bestellung leeren",
  "转台": "Tisch wechseln",
  "打印预结单": "Vorabrechnung drucken",
  "催菜": "Bestellung beschleunigen",
  "人数": "Anzahl der Gäste",
  "订单来源": "Bestellquelle",
  "请点击左侧桌号台": "Bitte klicken Sie auf die Tischnummer links",
  "点选已开台桌台，可以在此查看点餐信息。": "Wählen Sie einen geöffneten Tisch aus, um hier Bestelldetails anzuzeigen.",
  "服务费": "Servicegebühr",
  "税费": "Steuer",
  "协助点餐": "Hilfe bei der Bestellung",
  "协助加餐": "Hilfe beim Hinzufügen von Artikeln",
  "结账": "Abrechnen",
  "完成": "Fertig",
  "价格": "Preis",
  "请选择": "Bitte auswählen",
  "确定要打印小票吗?": "Sind Sie sicher, dass Sie den Beleg drucken möchten?",
  "确定要关闭桌台并取消订单吗?": "Sind Sie sicher, dass Sie den Tisch schließen und die Bestellung stornieren möchten?",
  "请选择桌号": "Bitte wählen Sie eine Tischnummer aus",
  "就餐人数": "Anzahl der Esser",
  "下单": "Bestellen",
  "返回": "Zurück",
  "确定要商品删行吗?": "Sind Sie sicher, dass Sie die Artikelzeile löschen möchten?",
  "请选择就餐人数": "Bitte wählen Sie die Anzahl der Esser aus",
  // ============= 桌台 end ============

  // ============= 订单 start ============
  "下单时间": "Bestellzeit",
  "起始时间": "Startzeit",
  "店内订单": "Bestellung im Laden",
  "自提订单": "Abholbestellung",
  "外卖订单": "Lieferbestellung",
  "名称": "Name",
  "支付时间": "Zahlungszeit",
  "消费方式": "Zahlungsmethode",
  "状态": "Status",
  "单价": "Stückpreis",
  "金额": "Betrag",
  "税率": "Steuersatz",
  "税费金额": "Steuerbetrag",
  "邮箱地址": "E-Mail-Adresse",
  "今天": "Heute",
  "昨天": "Gestern",
  "一周": "Eine Woche",
  "搜索": "Suche",
  "待完成": "Ausstehend",
  "已完成": "Abgeschlossen",
  "已取消": "Abgebrochen",
  "全部": "Alle",
  "顾客信息": "Kundeninformationen",
  "用户昵称": "Benutzername",
  "手机号": "Telefonnummer",
  "收货地址": "Lieferadresse",
  "取单号": "Abholnummer der Bestellung",
  "就餐方式": "Essensart",
  "订单号": "Bestellnummer",
  "订单金额": "Bestellbetrag",
  "订单优惠": "Bestellrabatt",
  "实付金额": "Tatsächlicher Bezahltbetrag",
  "支付方式": "Zahlungsmethode",
  "备注信息": "Anmerkungen",
  "期望配送时间": "Erwartete Lieferzeit",
  "取餐时间": "Abholzeit",
  "配送费": "Liefergebühr",
  "退款金额": "Rückerstattungsbetrag",
  "准备中": "In Vorbereitung",
  "出餐中": "In Zubereitung",
  "待取餐": "Warten auf Abholung",
  "订单信息": "Bestellinformationen",
  "税费详情": "Steuerdetails",
  "取消订单": "Bestellung stornieren",
  "打印小票": "Beleg drucken",
  "出餐": "Gerichte servieren",
  "确认送达": "Lieferung bestätigen",
  "退款": "Rückerstattung",
  "已退款": "Rückerstattet",
  "请输入订单号": "Bitte geben Sie die Bestellnummer ein",
  "至": "Bis",
  "开始日期": "Startdatum",
  "结束日期": "Enddatum",
  "发送账单": "Rechnung senden",
  "请输入邮箱地址": "Bitte geben Sie Ihre E-Mail-Adresse ein",
  "确定要催菜吗?": "Sind Sie sicher, dass Sie die Bestellung beschleunigen möchten?",
  "确定要完成订单吗?": "Sind Sie sicher, dass Sie die Bestellung abschließen möchten?",
  "确定要出餐吗?": "Sind Sie sicher, dass Sie die Gerichte servieren möchten?",
  "确定要发送账单吗?": "Sind Sie sicher, dass Sie die Rechnung senden möchten?",
  "邮箱不能为空": "E-Mail darf nicht leer sein",
  "确定要取消订单吗?": "Sind Sie sicher, dass Sie die Bestellung stornieren möchten?",
  "是否确认此操作?": "Sind Sie sicher, dass Sie diese Aktion bestätigen möchten?",
  "上传文件只能是excel格式!": "Hochgeladene Datei muss im Excel-Format sein!",
  "上传文件大小不能超过 10MB!": "Die Größe der hochgeladenen Datei darf 10 MB nicht überschreiten!",
  "正在处理,请等待": "Verarbeitung läuft, bitte warten",
  "本次处理失败": "Verarbeitung fehlgeschlagen diesmal",
  "总金额": "Gesamtbetrag",
  "可退款金额": "Rückerstattbarer Betrag",
  "请输入退款金额": "Bitte geben Sie den Rückerstattungsbetrag ein",
  "超出可退款金额": "übersteigt den rückerstattbaren Betrag",
  "404错误页面": "404 Fehlerseite",
  "合计": "Gesamt",
  "份": "Portion",
  "余额支付": "Guthabenzahlung",
  "线下支付(现金支付)": "Offline-Zahlung (Barzahlung)",
  "线下支付(自有微信支付)": "Offline-Zahlung (WeChat-Zahlung)",
  "线下支付(自有支付宝支付)": "Offline-Zahlung (Alipay-Zahlung)",
  "线下支付(POS刷卡支付)": "Offline-Zahlung (POS-Kartenzahlung)",
  "进行中": "In Bearbeitung",
  "待付款": "Zahlung ausstehend",
  "待配送": "Ausstehende Lieferung",
  "配送中": "In Lieferung",
  "待接单": "In Erwartung der Annahme",
  "待取货": "Warten auf Abholung",
  "已配送": "Geliefert",
  "已收货": "Empfangen",
  "待收货": "Zu erhalten",
  "待取消": "Zu stornieren",
  "会员": "Mitglied",
  "商家": "Händler",
  "供应商": "Lieferant",
  "分销": "Distribution",
  "通知": "Benachrichtigung",
  "已付款": "Bezahlt",
  "用户下单": "Benutzerbestellung",
  "收银台下单": "Bestellung an der Kasse",
  "扫码下单": "Scannen zum Bestellen",
  "团购下单": "Gruppenbestellung",
  "商城订单": "Mall-Bestellung",
  "积分商城订单": "Punkte Mall-Bestellung",
  "余额充值订单": "Guthaben aufladen Bestellung",
  "购卡订单": "Kartenkauf Bestellung",
  "券包订单": "Gutscheinpaket Bestellung",
  "配送员押金订单": "Auslieferer Kaution Bestellung",
  "团购订单": "Gruppenkauf Bestellung",
  "下单减库存": "Bestandsreduzierung bei Bestellung",
  "付款减库存": "Bestandsreduzierung bei Zahlung",
  "商家配送": "Händlerlieferung",
  "外卖配送": "Takeaway-Lieferung",
  "到店自提": "Im Geschäft abholen",
  "快递配送": "Kurierdienst-Lieferung",
  "个人中心": "Persönliches Zentrum",
  ...deLocale
}

export default de



// WEBPACK FOOTER //
// ./src/i18n/langs/de.js